var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline03Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timeline_03_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 337.937,
    height: 503.928,
    viewBox: "0 0 337.937 503.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_849",
    "data-name": "Trazado 849",
    d: "M98.371,0H0",
    transform: "translate(0 333.5)",
    fill: "none",
    stroke: "#e2503f",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1211",
    "data-name": "Grupo 1211",
    transform: "translate(-457.533 -465.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_38",
    "data-name": "L\\xEDnea 38",
    y2: 262.5,
    transform: "translate(650 465.5)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1208",
    "data-name": "Grupo 1208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1206",
    "data-name": "Grupo 1206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1204",
    "data-name": "Grupo 1204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_191",
    "data-name": "Elipse 191",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "translate(541.176 892.48) rotate(-80.679)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_192",
    "data-name": "Elipse 192",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(538.22 812.187) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_03.",
    "data-name": 3,
    transform: "translate(572.683 750.313)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "03."))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1205",
    "data-name": "Grupo 1205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_78",
    "data-name": "Rect\\xE1ngulo 78",
    width: 284.937,
    height: 41.829,
    transform: "translate(510.533 927.599)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Junio_2018",
    "data-name": "Junio 2018",
    transform: "translate(593.104 958.09)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Junio 2018")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1207",
    "data-name": "Grupo 1207"
  }, /*#__PURE__*/React.createElement("text", {
    id: "I_Hackathon_3_prototipos",
    "data-name": "I Hackathon,  3 prototipos",
    transform: "translate(584.486 801.769)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.281,
    y: 23
  }, "I Hackathon, "), /*#__PURE__*/React.createElement("tspan", {
    x: 8.158,
    y: 53.117
  }, "3 prototipos")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1210",
    "data-name": "Grupo 1210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1209",
    "data-name": "Grupo 1209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_850",
    "data-name": "Trazado 850",
    d: "M709.008,724.492l-9.557,4.779L697.314,725l9.557-4.779Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_851",
    "data-name": "Trazado 851",
    d: "M706.871,762.725l-9.558-4.779,2.138-4.274,9.557,4.779Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_852",
    "data-name": "Trazado 852",
    d: "M700.77,739.082h9.717v4.778H700.77Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_853",
    "data-name": "Trazado 853",
    d: "M632.547,720.219,642.1,725l-2.137,4.274-9.557-4.779Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_854",
    "data-name": "Trazado 854",
    d: "M632.546,762.723l-2.137-4.274,9.557-4.779,2.137,4.275Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_855",
    "data-name": "Trazado 855",
    d: "M628.93,739.082h9.717v4.778H628.93Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_856",
    "data-name": "Trazado 856",
    d: "M662.54,791.966h14.336v4.779H662.54Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_857",
    "data-name": "Trazado 857",
    d: "M695.991,741.471a26.283,26.283,0,1,0-38.23,23.378v7.684h-4.778v4.778h4.778v9.876h23.894v-9.876h4.779v-4.778h-4.779v-7.684A26.3,26.3,0,0,0,695.991,741.471Zm-19.115,40.938H662.54v-5.1h14.336Zm-9.557-36.159a2.39,2.39,0,1,1,2.389,2.389A2.392,2.392,0,0,1,667.319,746.25Zm4.779,26.283V753.007a7.169,7.169,0,1,0-4.779,0v19.526H662.54V761.779l-1.429-.627a21.5,21.5,0,1,1,17.2,0l-1.43.627v10.754Z",
    fill: "#1f2121"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline03Icuida);
export default __webpack_public_path__ + "static/media/timeline_03_icuida.2a09418f68ea1de7f420080c73b64d4a.svg";
export { ForwardRef as ReactComponent };